module.exports = __webpack_public_path__ + "static/media/KapOrg-logo.6e31e505.svg";